import { State } from "./state";
import { ErrorSeverity } from "./types";
import { PropertyValueSet } from "@genesys/property";
import * as Load from "./load";

export function GetErrorSeverity(
  state: State,
  loadDef: Load.LoadDef,
  currentTopLevelMoistureLoadSettings: PropertyValueSet.PropertyValueSet
): ErrorSeverity {
  const activeLoadStates = Object.values(state.activeLoads);

  const loadTypeNames = activeLoadStates.map(load => load.name);
  const isLoadNameDuplicated =
    loadTypeNames.length !== new Set(loadTypeNames).size;

  const activeLoadError = activeLoadStates.map(load =>
    Load.GetErrorSeverity(
      load,
      loadDef,
      currentTopLevelMoistureLoadSettings,
      state.propertyDefinitions
    )
  );

  const errorOrWarnings = [
    ...activeLoadError,
    isLoadNameDuplicated ? "error" : "none"
  ];

  return errorOrWarnings.includes("error")
    ? "error"
    : errorOrWarnings.includes("warning")
    ? "warning"
    : "none";
}
